import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Icon24 from 'builder/components/Icon'
import Media from 'builder/styles/media'

export const Wrapper = styled.div<{ $width: number }>`
  padding: 20px;
  background-color: ${Colors.White};
  width: ${({ $width }) => $width}px;
  border-radius: 12px;
  ${Media.Phone`
    max-width: none;
    height: 100%;
    padding: 20px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  `};
`
export const CloseIconContainer = styled.div`
  height: 24px;
  width: 24px;
  flex: 0 0 auto;
  background-color: ${Colors.Neutral10};
  color: ${Colors.Neutral50};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    color: ${Colors.Blue50};
    background-color: ${Colors.Blue10};
  }
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.div`
  ${Typography.Subhead};
  ${FontWeights.Medium};
  color: ${Colors.Neutral90};
`

export const CloseIcon = styled(Icon24.Close)`
  height: 20px;
  width: 20px;
`
